import { useAxiosRequest } from "api/axiosRequest";
import { BASE_URL } from "api/url_helper"

export interface UploadPortHolidayResponse {
  holiday_code: string
  locode: string
  description: string
  start_date: string
  end_date: string
  source: 'bimco' | 'user'
  created_at: string
  updated_at: string
}

export interface PortHoliday {
  locode: string
  bimco_locode: string
  source: string
  holiday_scope: string
  remarks: string
  name: string
  start_date: string
  end_date: string
}
export interface PortHolidayResponse {
  holidays: PortHoliday[]
  errors: string[]
}

export function usePortHolidayAPI() {
  const request = useAxiosRequest()

  async function uploadHolidays(portHolidays: PortHoliday[]) {
    try {
      const response = await request<
        PortHoliday[],
        { message: boolean; holidays: UploadPortHolidayResponse[] }
      >({
        method: "POST",
        url: `${BASE_URL}/port-predictor/holidays`,
        data: portHolidays,
      });

      return response?.data; // Return the response data for further use
    } catch (err) {
      console.error("Error uploading holidays:", err);
      throw new Error("Failed to upload holidays.");
    }
  }

  async function deleteAllHolidaysInCache() {
    try {
      await request<void, void>({
        method: "DELETE",
        url: `${BASE_URL}/port-predictor/holidays`
      });

    } catch (err) {
      console.error("Error deleting holiday in cache:", err);
      throw new Error("Failed to delete holidays.");
    }
  }


  async function getPortHolidays({ locode, startDate, endDate }: {
    locode: string
    startDate: string
    endDate: string
  }) {
    return request<any, PortHolidayResponse>({
      url: `${BASE_URL}/port-predictor/holidays`,
      params: {
        locode,
        start_date: startDate,
        end_date: endDate,
      }
    }).then((response) => response?.data).catch((error) => {
      if (error.response) {
        throw error
      } else {
        throw new Error("Network or other error")
      }
    })
  }

  return {
    uploadHolidays,
    getPortHolidays,
    deleteAllHolidaysInCache
  }
}